import { isEnum, isReadOnly } from 'customer-data-objects/property/PropertyIdentifier';
import { isExternalOptionsProperty } from 'reference-resolvers-lite/utils/isExternalOptionsProperty';
import { getPipelineStagePropertyName } from '../input/pipeline/utils/pipelineUtils';
import { isCustomExternalOptionsProperty } from '../resolvers/isCustomExternalOptionsProperty';
export const isDependentCpoProperty = (rules, property) => {
  return rules.some(rule => rule.dependentFieldName === property.name);
};
export const isControllingCpoProperty = (rules, property) => {
  return rules.some(rule => rule.controllingField.fieldName === property.name);
};
export const isCpoProperty = (rules, property) => {
  return rules.some(rule => rule.dependentFieldName === property.name || rule.controllingField.fieldName === property.name);
};
export const isEligibleCpControllingProperty = property => {
  return isEnum(property) && !isReadOnly(property);
};
export const isEligibleCpoProperty = ({
  property,
  objectTypeId
}) => {
  const pipelineStagePropertyName = getPipelineStagePropertyName(objectTypeId);

  // For pipeline stage properties (deal stage, ticket stage, etc.), users can change stage using drag and drop on the board.
  // As of Feb 2024, CPO rules are not enforced on the board (columns are not disabled),
  // so edit modal does not allow setting up CPO rules for pipeline stage properties.
  // Before enabling CPO for pipeline stage properties, please work with the #crm-pipelines team.
  // CPO could contradict governance rules like "don't allow skipping stages".
  const isPipelineStageProperty = property.name === pipelineStagePropertyName;
  if (isPipelineStageProperty) {
    return false;
  }
  if (!isEnum(property)) {
    return false;
  }
  if (isCustomExternalOptionsProperty(property, objectTypeId) || isExternalOptionsProperty(property, objectTypeId)) {
    return false;
  }
  return true;
};